import React from 'react'

const RightArrow: React.FC = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.16671 0.5L0.874207 1.7925L5.07254 6L0.874207 10.2075L2.16671 11.5L7.66671 6L2.16671 0.5Z"
        fill="#003760"
      />
    </svg>
  )
}

export default RightArrow
